import React, { useState } from 'react';
import Barras from '../home/Barras';
import {
  AREAS_DO_PAINEL,
  AREAS_EM_ORDEM,
  EXECUCAO,
  PESOS,
  ROTULO_DA_AREA,
  decimalEm,
  notaDe,
  perdaDe
} from '../home/amostra';
import { useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/Notas.css';

/**
 * A conta da nota para o leitor mexer, dentro do post que a explica. Parte da
 * execução de exemplo da home e recalcula com `calcularScore` (via `notaDe`), a
 * mesma função do painel. Zero página dá "sem nota", que é o argumento do post.
 */
const Calculadora = () => {
  const { t } = useIdioma();
  const { numero, locale } = useFormato();
  const decimal = decimalEm(locale);
  const [total, setTotal] = useState(EXECUCAO.total);
  const [afetadas, setAfetadas] = useState(EXECUCAO.afetadas);

  /* Uma área não afeta mais páginas do que as rastreadas. */
  const contadas = Object.fromEntries(AREAS_EM_ORDEM.map((a) => [a, Math.min(afetadas[a], total)]));
  const perdas = Object.fromEntries(
    AREAS_EM_ORDEM.map((a) => [a, total ? perdaDe(a, contadas[a], total) : 0])
  );
  const nota = notaDe(contadas, total);

  return (
    <section className="notas-calc" aria-labelledby="calc-titulo" data-r>
      <h3 id="calc-titulo">{t('notas.calcTitulo')}</h3>
      <p>{t('notas.calcTexto')}</p>
      <p className="notas-calc-nota" aria-live="polite">
        <output className="nh-num">{nota ?? '—'}</output>
        <span>{nota === null ? t('notas.calcSemNota') : t('inicio.tela.deCem')}</span>
      </p>
      <div aria-hidden="true">
        <Barras
          areas={AREAS_EM_ORDEM}
          pesos={PESOS}
          perdas={perdas}
          rotulo={(area) => t(ROTULO_DA_AREA[area])}
          decimal={decimal}
        />
      </div>

      <div className="notas-calc-controles">
        <label className="notas-calc-controle">
          <span className="notas-calc-topo">{t('notas.calcPaginas')}</span>
          <input
            type="number"
            inputMode="numeric"
            min="0"
            value={total}
            onChange={(e) => setTotal(Math.max(0, Math.floor(Number(e.target.value) || 0)))}
          />
        </label>
        {AREAS_DO_PAINEL.map((area) => (
          <label className="notas-calc-controle" key={area}>
            <span className="notas-calc-topo">
              <span>{t(`inicio.areas.controle.${area}`)}</span>
              <output className="nh-num">
                {t('inicio.areas.deTotal', { n: numero(contadas[area]), total: numero(total) })}
              </output>
            </span>
            <input
              type="range"
              min="0"
              max={total}
              value={contadas[area]}
              onChange={(e) => setAfetadas((atual) => ({ ...atual, [area]: Number(e.target.value) }))}
            />
          </label>
        ))}
      </div>
    </section>
  );
};

export default Calculadora;
